(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["italoil-cart-core-cta"] && !Shopify.designMode) return;
  try {
    (() => {
		const selector = "[data-italoil-cart-core-cta]";

		const setup = (scope = document) => {
			const docks = scope.matches?.(selector)
				? [scope]
				: Array.from(scope.querySelectorAll?.(selector) || []);

			docks.forEach((dock) => {
				if (dock.dataset.italoilCartCoreCtaReady === "true") {
					return;
				}

				const drawer = dock.closest(".js-cart-drawer");
				if (!drawer) {
					return;
				}

				dock.dataset.italoilCartCoreCtaReady = "true";

				const sync = () => {
					dock.hidden = drawer.classList.contains("is-empty");

					const source = drawer.querySelector(".cart-footer__subtotal-value");
					const target = dock.querySelector("[data-italoil-cart-core-cta-subtotal]");

					if (!source || !target) {
						return;
					}

					const subtotal = source.textContent.trim();
					if (target.textContent !== subtotal) {
						target.textContent = subtotal;
					}
				};

				let pending = false;
				const requestSync = () => {
					if (pending) {
						return;
					}

					pending = true;
					window.requestAnimationFrame(() => {
						pending = false;
						sync();
					});
				};

				new MutationObserver(requestSync).observe(drawer, {
					attributes: true,
					attributeFilter: ["class"],
					characterData: true,
					childList: true,
					subtree: true
				});

				sync();
			});
		};

		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", () => setup(), { once: true });
		} else {
			setup();
		}

		document.addEventListener("shopify:section:load", (event) => setup(event.target));
	})();
  } catch(e) { console.error(e); }
})();

})();
